import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { QueryKey } from '@tanstack/react-query'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { getWallboxConfiguration } from '../api'
import { usePortalQuery } from 'src/Libs/api'

type UseWallboxConfigurationQuery = {
  data: WallboxConfigurationModel | null
  isLoading?: boolean
  isError?: boolean
}

export const getWallboxConfigurationQueryKey = (wallboxStorageId: string, wallboxIndex: string): QueryKey => [
  'wallbox-configuration',
  wallboxStorageId,
  wallboxIndex,
]

const useWallboxConfigurationQuery = ({
  wallboxStorageId,
  wallboxIndex,
  enabled = true,
}: {
  wallboxStorageId: string
  wallboxIndex: string
  enabled?: boolean
}): UseWallboxConfigurationQuery => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: getWallboxConfigurationQueryKey(wallboxStorageId, wallboxIndex),
    queryFn: () => getWallboxConfiguration(wallboxStorageId, wallboxIndex, authFetch),
    enabled: Boolean(wallboxStorageId) && enabled,
  })

  return { data: data || null, isLoading, isError }
}

export default useWallboxConfigurationQuery
